import { Injectable } from '@angular/core';
import { EMPTY, Observable, ReplaySubject } from 'rxjs';
import { UserService } from '../services/user.service';
import { User } from '@shared/models/user.model';
import { catchError, publishReplay, refCount, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PrincipalService {
    private user$: Observable<User>;
    private activeUser: ReplaySubject<User> = new ReplaySubject<User>(1);
    private userIdentity: User = null;

    constructor(private userService: UserService) { }

    private getUserInfo() {
        const idToken = JSON.parse(localStorage.getItem('okta-token-storage'))['idToken']['idToken'];
        if (idToken) {
            this.user$ = this.userService.getUser(idToken)
                .pipe(
                    catchError(() => {
                        this.user$ = EMPTY;
                        this.activeUser.complete();
                        return EMPTY;
                    }),
                    tap((user: User) => {
                        this.userIdentity = user;
                        this.activeUser.next(user);
                    }),
                    publishReplay(1),
                    refCount()
                );
        } else {
            this.user$ = EMPTY;
        }
    }

    hasAnyAuthority(authorities: string[]): boolean {
        if (this.userIdentity === null || this.user$ === EMPTY) {
            return false;
        }
        for (let i = 0; i < authorities.length; i++) {
            if (this.userIdentity.authorities.indexOf(authorities[i]) !== -1) {
                return true;
            }
        }
        return false;
    }

    getUser() {
        if (!this.user$ || this.user$ === EMPTY) {
            this.getUserInfo();
        }
        return this.user$;
    }

    getActiveUser(): ReplaySubject<User> {
        return this.activeUser;
    }

    getAuthorities(): String[] {
        if (this.userIdentity && this.userIdentity.authorities) {
            return this.userIdentity.authorities;
        } else {
            return [];
        }
    }

    reset() {
        this.user$ = null;
        this.userIdentity = null;

        // cleanup localStorage
        localStorage.removeItem("idToken");
    }
}